import {
  ResolutionTypeSet,
  useResolutionExhibitTypeOptions,
} from 'hooks/useResolutionExhibitTypeOptions';
import { useMemo, useState } from 'react';
import { ItemDropDown } from './ItemEdit';

type ActionNameEditType = Pick<ResolutionTypeSet, 'actionNameId'>;

export type ActionNameEditProps = {
  value: ActionNameEditType | null;
  onChange: (item: ActionNameEditType) => void;
};

export const ActionNameEdit = ({ value = {}, onChange }: ActionNameEditProps) => {
  const inputValue: ActionNameEditType = value ?? {};
  const { actionNameId } = inputValue;

  const [resolutionTypeId, setResolutionTypeId] = useState(1);
  const [actionSubStatusId, setActionSubStatusId] = useState(0);

  const resolutionOptions = useResolutionExhibitTypeOptions();

  const resolutionSubstatusOptions = useMemo(
    () => resolutionOptions.resolutionSubstatusOptions(resolutionTypeId),
    [resolutionTypeId], // eslint-disable-line react-hooks/exhaustive-deps
  );

  const resolutionNameOptions = useMemo(
    () =>
      resolutionOptions.resolutionNameOptions(resolutionTypeId, actionSubStatusId),
    [resolutionTypeId, actionSubStatusId], // eslint-disable-line react-hooks/exhaustive-deps
  );

  const handleStatusChange = (selected: string) => {
    const newId = +selected;
    const newValue = resolutionOptions.getResolutionTypeChangedValues(newId, {});

    setResolutionTypeId(newValue.resolutionTypeId ?? 0);
    setActionSubStatusId(newValue.actionSubStatusId ?? 0);
    onChange({ actionNameId: newValue.actionNameId });
  };

  const handleSubStatusChange = (selected: string) => {
    const newId = +selected;
    const newValue = resolutionOptions.getResolutionSubTypeChangedValues(
      resolutionTypeId,
      newId,
    );
    setActionSubStatusId(newValue.actionSubStatusId ?? 0);
    onChange({ actionNameId: newValue.actionNameId });
  };

  const handleResolutionNameChange = (selected: string) => {
    onChange({ actionNameId: +selected });
  };

  return (
    <>
      <ItemDropDown
        label="Resolution type"
        value={`${resolutionTypeId}`}
        options={resolutionOptions.resolutionStatusOptions}
        onChange={handleStatusChange}
      />

      <ItemDropDown
        label="Resolution subtype"
        value={`${actionSubStatusId}`}
        options={resolutionSubstatusOptions}
        onChange={handleSubStatusChange}
      />

      <ItemDropDown
        label="Resolution name"
        value={`${actionNameId}`}
        options={resolutionNameOptions}
        onChange={handleResolutionNameChange}
      />
    </>
  );
};
